import { render, staticRenderFns } from "./SeparateDateRangePicker.vue?vue&type=template&id=b60673f4&scoped=true&"
import script from "./SeparateDateRangePicker.vue?vue&type=script&lang=ts&"
export * from "./SeparateDateRangePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60673f4",
  null
  
)

export default component.exports